export const phoneOnPasteRegexPattern =
  /[^0-9+]|^(\+00)|^(00\+)|^(\+0)|^(0\+)|^(\+\+)|^(000)/g;
export const phoneOnChangeRegexPattern =
  /^(\+00)|^(00\+)|^(\+0)|^(0\+)|^(\+\+)|^(000)/;
export const phoneAllowedRegexPattern = /([0-9])|(\+)/;
